module.exports = "DELETED_WORKERNODE";